import { currentLang } from '../utils/getLanguage';
import { $Q, $Qll } from "../utils/querySelector";

class ContactUs {

  constructor(queryHeader) {
    this.header = $Q(queryHeader)

    if (this.header) {
      this._init();
    }
  }

  _init() {
    this._languague();
  }

  _languague() {
    let currentLanguage = currentLang;
    this._getUrl(currentLanguage);
  }

  _getUrl(lang) {
    const menuItemsQuery = $Qll('[name="multilinks-items"]');

    menuItemsQuery.forEach(menuItemQuery => {

      const menuItem = $Qll(`.${menuItemQuery.value}`);

      menuItem.forEach(item => {
        const urlEn = $Q(`.link-${menuItemQuery.value}-en`).value;
        const urlFr = $Q(`.link-${menuItemQuery.value}-fr`).value;
        const urlGer = $Q(`.link-${menuItemQuery.value}-de`).value;
        const urlNl = $Q(`.link-${menuItemQuery.value}-nl`).value;

        let langs = new Map([
          ["en", urlEn],
          ["fr", urlFr],
          ["de", urlGer],
          ["nl", urlNl]
        ])

        this._changeUrl(lang, langs, item);
      });

    });

  }

  _changeUrl(lang, langs, item) {
    const url = langs.get(lang);

    item.href = url || item.href;
    item.target = "_blank";
  }
}

export { ContactUs }

